import script from "./AsesoriaLegalView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsesoriaLegalView.vue?vue&type=script&setup=true&lang=js"

import "./AsesoriaLegalView.vue?vue&type=style&index=0&id=62f870ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f870ba"]])

export default __exports__